export class SoglasjeSDDERacunForm {

  steps = [
    "Osebni podatki",
    "Način komunikacije",
    "Kontakt",
    "Način plačila",
    "Podpis soglasja"
  ];

  constructor() {
  }

}
